import styled from 'styled-components';
import TypographyMUI from '@material-ui/core/Typography';

export const CenteredText = styled(TypographyMUI)`
    font-family: Roboto, Arial, 'sans-serif';
    font-size: 18px;
    text-align: center;
    margin-top: 0px;
`;

export const Link = styled.a`
    font-size: 18px;
    color: black;
    text-decoration: none;
`;

export const CollumsImageArea = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
`;

export const CollumsImage = styled.img`
    height: 300px;
`;
